var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { action: "#" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
      },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c("h3", { staticClass: "h5 font-weight-bold mb-3" }, [
            _vm._v("Žadatel"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.name,
                    expression: "values.name",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "Name",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.values, "name", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.phone,
                    expression: "values.phone",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "tel",
                  id: "Phone",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.values, "phone", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(1),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.email,
                    expression: "values.email",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "email",
                  id: "Email",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.values, "email", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(2),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "custom-control custom-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.isEucEmployee,
                    expression: "values.isEucEmployee",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "isEucEmployee" },
                domProps: {
                  checked: Array.isArray(_vm.values.isEucEmployee)
                    ? _vm._i(_vm.values.isEucEmployee, null) > -1
                    : _vm.values.isEucEmployee,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.values.isEucEmployee,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.values,
                            "isEucEmployee",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.values,
                            "isEucEmployee",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.values, "isEucEmployee", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "isEucEmployee" },
                },
                [_vm._v("\n            Jsem zaměstnanec EUC a.s.\n          ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.values.isEucEmployee,
                  expression: "values.isEucEmployee",
                },
              ],
              staticClass: "form-group",
            },
            [
              _c("div", { staticClass: "mb-2 custom-placeholder" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.values.workPosition,
                      expression: "values.workPosition",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "WorkPosition", placeholder: " " },
                  domProps: { value: _vm.values.workPosition },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.values,
                        "workPosition",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(3),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "small mb-4" }, [
                _vm._v(
                  "\n          (dle zákona č.96/2004 sb. O nelékařských zdravotnických\n          pracovnících)\n        "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("h3", { staticClass: "h5 font-weight-bold mb-3" }, [
            _vm._v("Předmět žádosti"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.completeAmount,
                    expression: "values.completeAmount",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "completeAmount",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.completeAmount },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.values,
                      "completeAmount",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(4),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.requestedAmount,
                    expression: "values.requestedAmount",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "requestedAmount",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.requestedAmount },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.values,
                      "requestedAmount",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(5),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mb-4" }, [
            _c("div", { staticClass: "custom-file" }, [
              _c("input", {
                staticClass: "custom-file-input",
                attrs: { type: "file", id: "attachments", multiple: "" },
                on: { change: _vm.handleFiles },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-file-label text-truncate pr-5",
                  attrs: { for: "attachments" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.attachmentsLabel) +
                      "\n          "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "mb-4 custom-placeholder" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.values.message,
                    expression: "values.message",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  id: "message",
                  rows: "4",
                  placeholder: " ",
                  required: "",
                },
                domProps: { value: _vm.values.message },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.values, "message", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(7),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "custom-control custom-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.gdprAgreement,
                    expression: "values.gdprAgreement",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "GdprAgreement", required: "" },
                domProps: {
                  checked: Array.isArray(_vm.values.gdprAgreement)
                    ? _vm._i(_vm.values.gdprAgreement, null) > -1
                    : _vm.values.gdprAgreement,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.values.gdprAgreement,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.values,
                            "gdprAgreement",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.values,
                            "gdprAgreement",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.values, "gdprAgreement", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(8),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "custom-control custom-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.marketingAgreement,
                    expression: "values.marketingAgreement",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "MarketingAgreement" },
                domProps: {
                  checked: Array.isArray(_vm.values.marketingAgreement)
                    ? _vm._i(_vm.values.marketingAgreement, null) > -1
                    : _vm.values.marketingAgreement,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.values.marketingAgreement,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.values,
                            "marketingAgreement",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.values,
                            "marketingAgreement",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.values, "marketingAgreement", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(9),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "custom-control custom-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.truthfulStatement,
                    expression: "values.truthfulStatement",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "checkbox",
                  id: "truthfulStatement",
                  required: "",
                },
                domProps: {
                  checked: Array.isArray(_vm.values.truthfulStatement)
                    ? _vm._i(_vm.values.truthfulStatement, null) > -1
                    : _vm.values.truthfulStatement,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.values.truthfulStatement,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.values,
                            "truthfulStatement",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.values,
                            "truthfulStatement",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.values, "truthfulStatement", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "truthfulStatement" },
                },
                [
                  _vm._v(
                    '\n            Prohlašuji, že všechny údaje v tomto dotazníku a v přílohách jsou\n            pravdivé. Souhlasím tím, že Nadační fond EUC „Elucidate" si může\n            ověřit na příslušném personálním oddělení mého zaměstnavatele\n            skutečnosti o formě a rozsahu mého pracovního poměru.\n          '
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _vm.error.showing
            ? _c("div", { staticClass: "alert alert-secondary mb-4" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.error.text
                        ? _vm.error.text
                        : "Něco se nezdařilo, zkuste to prosím později"
                    ) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "submit", disabled: _vm.isSending },
              },
              [_vm._v("\n          " + _vm._s(_vm.buttonText) + "\n        ")]
            ),
          ]),
          _vm._v(" "),
          _vm._m(10),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "Name" } },
      [_c("span", [_vm._v(" Jméno a příjmení ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "Phone" } },
      [_c("span", [_vm._v(" Kontaktní telefon ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "Email" } },
      [_c("span", [_vm._v(" E-mail ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "WorkPosition" } },
      [_c("span", [_vm._v(" Název pracovní pozice ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "completeAmount" } },
      [_c("span", [_vm._v(" Potřebná částka celkem ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "requestedAmount" } },
      [
        _c("span", [
          _vm._v(
            "\n              Částka požadovaná od Nadačního fondu EUC,,Elucidate“\n            "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "col-lg-5 mb-4 pt-lg-4 mt-lg-2 text-primary order-first order-lg-0",
      },
      [
        _c("p", [
          _vm._v(
            "\n        Řádné vyplnění této žádosti jsou nezbytnými předpoklady, aby Nadační\n        fond EUC „Elucidate“ mohl zvážit možnost uzavření smlouvy o poskytnutí\n        nadačního příspěvku s žadatelem.\n      "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "label-floating", attrs: { for: "message" } },
      [_c("span", [_vm._v(" Předmět žádosti ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "custom-control-label", attrs: { for: "GdprAgreement" } },
      [
        _vm._v("\n            Seznámil/a jsem se s\n            "),
        _c(
          "a",
          {
            attrs: { href: "/o-nas/ochrana-osobnich-udaju/", target: "_blank" },
          },
          [_vm._v("Podmínkami ochrany osobních údajů.")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      {
        staticClass: "custom-control-label",
        attrs: { for: "MarketingAgreement" },
      },
      [
        _vm._v(
          "\n            Souhlasím s využitím osobních údajů za účelem\n            "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "/files/souhlas-se-zpracovanim-ou-zpetna-vazba.pdf",
              target: "_blank",
            },
          },
          [_vm._v("získání zpětné vazby")]
        ),
        _vm._v("\n            a se\n            "),
        _c(
          "a",
          {
            attrs: {
              href: "/files/souhlas-se-zpracovanim-ou-marketing.pdf",
              target: "_blank",
            },
          },
          [_vm._v("zasíláním marketingových sdělení")]
        ),
        _vm._v(".\n          "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "mt-3 text-gray-lighter font-size-small" },
      [
        _c("p", [
          _vm._v(
            "\n          Tato stránka je chráněna systémem reCAPTCHA od Google s\n          "
          ),
          _c(
            "a",
            {
              staticClass: "text-gray-lighter",
              attrs: {
                href: "https://policies.google.com/privacy",
                target: "_blank",
              },
            },
            [_c("u", [_vm._v("ochranou soukromí")])]
          ),
          _vm._v("\n          a\n          "),
          _c(
            "a",
            {
              staticClass: "text-gray-lighter",
              attrs: {
                href: "https://policies.google.com/terms",
                target: "_blank",
              },
            },
            [_c("u", [_vm._v("podmínkami používání")])]
          ),
          _vm._v(".\n        "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }